import { render, staticRenderFns } from "./OrganizationSidebar.vue?vue&type=template&id=6a219a9a&scoped=true"
import script from "./OrganizationSidebar.vue?vue&type=script&lang=js"
export * from "./OrganizationSidebar.vue?vue&type=script&lang=js"
import style0 from "./OrganizationSidebar.vue?vue&type=style&index=0&id=6a219a9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a219a9a",
  null
  
)

export default component.exports